export default __webpack_public_path__ + "static/media/sercome.915dfa74.webp";